import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import { preloaderStore } from '@stores/preloaderStore';
import type { CmApi,ControlDto } from '@src/api';

import { controlsStore } from '../controlsStore';

class ControlEditStore {
  control: ControlDto | null;

  isNew = false;

  editMode = false;

  isLoading = false;

  api: CmApi;

  hiddenEdit = false;

  hiddenDelete = false;

  hiddenClean = false;

  hiddenSave = false;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    this.control = null;

    makeAutoObservable(this);
  }

  get isEditMode() {
    return this.editMode || this.isNew;
  }

  setNew = (isNew = true) => {
    this.isNew = isNew;
    this.control = null;
  };

  setEditMode = (editMode = true) => {
    this.editMode = editMode;
  };

  save = async (control: ControlDto) => {
    preloaderStore.preloader(true);
    const { data } = await (this.isNew
      ? this.api.controls.addControl(control)
      : this.api.controls.updateControlByCode(control));

    if (data) {
      controlsStore.setIsChanged(true);

      if (this.isNew) {
        preloaderStore.preloader(false);
        return { ctrlCode: data.ctrlCode };
      }
      runInAction(() => {
        this.control = data;
        this.setEditMode(false);
      });
    }
    preloaderStore.preloader(false);
    return undefined;
  };

  delete = async () => {
    if (this.control) {
      await this.api.controls.deleteControlByCode(this.control.ctrlCode ?? '');
      controlsStore.setIsChanged(true);
    }
  };

  fetch = async (ctrlCode?: string): Promise<void> => {
    if (!ctrlCode) {
      return;
    }
    preloaderStore.preloader(true);
    runInAction(() => {
      this.isLoading = true;
      this.setEditMode(false);
      this.setNew(false);
    });

    const { data } = await this.api.controls.getControlByCtrlCode(ctrlCode);

    runInAction(() => {
      this.control = data;
      this.isLoading = false;
    });
    preloaderStore.preloader(false);
  };

  setHiddenEdit = (hiddenEdit = true): void => {
    this.hiddenEdit = hiddenEdit;
  };

  setHiddenDelete = (hiddenDelete = true): void => {
    this.hiddenDelete = hiddenDelete;
  };

  setHiddenClean = (hiddenClean = true): void => {
    this.hiddenClean = hiddenClean;
  };

  setHiddenSave = (hiddenSave = true): void => {
    this.hiddenSave = hiddenSave;
  };
}

export const controlEditStore = new ControlEditStore({ api: cmApi });
